import React from 'react';
import ShippingTelEndBox from '../../shippingTelEndBox';
import { IshipAddres, ShippingFieldsProps } from '../../interfaces';
import LocationSelector from '../../locationSelector';
import ShippingCityPostcode from '../../shippingCityAndPostcode';
import ShippingAddresses from '../../shippingAddresses';
import ShippingNames from '../../shippingNames';

const ShippingFields = ({
  errors,
  handleCountryChange,
  handleProvinceChange,
  setAddressValidationMessage,
  setUserInfo,
  updateButtonClicked,
  userInfo,
}: ShippingFieldsProps) => {
  const updateUserInfo = (data: Partial<IshipAddres>) => {
    setAddressValidationMessage(null);
    setUserInfo((prev) => ({ ...prev, ...data }));
  };

  return (
    <div className="shipping-info">
      <ShippingNames
        initialFirstName={userInfo.firstName}
        initialLastName={userInfo.lastName}
        onUpdate={updateUserInfo}
        errors={errors}
        updateButtonClicked={updateButtonClicked}
      />
      <ShippingAddresses
        initialAddressLine1={userInfo.addressLine1}
        initialAddressLine2={userInfo.addressLine2 || ''}
        onUpdate={updateUserInfo}
        errors={errors}
        updateButtonClicked={updateButtonClicked}
      />
      <LocationSelector
        onCountryChange={handleCountryChange}
        onProvinceChange={handleProvinceChange}
        selectedCountry={userInfo.country}
        selectedProvince={userInfo.province ?? null}
        errors={errors}
        updateButtonClicked={updateButtonClicked}
      />
      <ShippingCityPostcode
        initialCity={userInfo.city}
        initialPostcode={userInfo.postcode}
        onUpdate={updateUserInfo}
        errors={errors}
        updateButtonClicked={updateButtonClicked}
      />
      <ShippingTelEndBox
        initialTelephone={userInfo.telephone}
        initialUseAddressForBilling={userInfo.useAddressForBilling}
        phoneCode={userInfo.phoneCode}
        emoji={userInfo.emoji}
        onUpdate={updateUserInfo}
        errors={errors}
        updateButtonClicked={updateButtonClicked}
      />
    </div>
  );
};

export default ShippingFields;
